export enum EmailTokenVerificationStatus {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  REJECTED = 'REJECTED',
}

export class VerifiedEmail {
  public email: string;
}

export class VerifiedPhone {
  public phone: string;
}
